import { useEffect, useState } from 'react'
import { CheckCircle, AlertCircle, X } from 'lucide-react'

interface ToastData {
  id: number
  type: 'success' | 'error' | 'info'
  message: string
  duration?: number
  action?: { label: string; onClick: () => void }
}

let toastId = 0
let addToastFn: ((toast: Omit<ToastData, 'id'>) => void) | null = null

// eslint-disable-next-line react-refresh/only-export-components
export function showToast(toast: Omit<ToastData, 'id'>) {
  addToastFn?.(toast)
}

export default function ToastContainer() {
  const [toasts, setToasts] = useState<ToastData[]>([])

  useEffect(() => {
    addToastFn = (toast) => {
      const id = ++toastId
      setToasts((prev) => [...prev, { ...toast, id }])
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id))
      }, toast.duration ?? 3000)
    }
    return () => { addToastFn = null }
  }, [])

  if (toasts.length === 0) return null

  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] flex flex-col gap-2 max-w-[400px] w-full px-4">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-xl shadow-lg animate-slide-up ${
            toast.type === 'success' ? 'bg-matcha text-white' :
            toast.type === 'error' ? 'bg-yokoso-red text-white' :
            'bg-navy text-white'
          }`}
        >
          {toast.type === 'success' ? <CheckCircle size={20} /> : <AlertCircle size={20} />}
          <span className="flex-1 text-sm font-medium">{toast.message}</span>
          {toast.action && (
            <button
              onClick={toast.action.onClick}
              className="text-sm font-bold underline"
            >
              {toast.action.label}
            </button>
          )}
          <button onClick={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}>
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  )
}
